import { Component, Input, OnInit } from '@angular/core';
import { ILabels } from "../../interfaces/ILabels";
import { Yii } from "../../interfaces/Yii";

@Component({
    selector: 'stops',
    template: `
        <div>
            <span *ngIf="nbStops == 1">1&nbsp;{{wording.stop}}</span>
            <span *ngIf="nbStops > 1">{{nbStops}}&nbsp;{{wording.stops}}</span>
            <span *ngIf="nbStops == 0">{{wording.noStop}}</span>
        </div>
    `
})

export class StopsComponent {

    @Input()
    public nbStops: number;

    public wording: ILabels = {
        stop: Yii.t('wui-shared-js', 'escale'),
        stops: Yii.t('wui-shared-js', 'escales'),
        noStop: Yii.t('wui-shared-js', 'direct'),
    };
}
